import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuPaintingPlanView } from "src/tenantCustomizations/tenants/mellano/views/luukku/productionPlanning/MellanoLuukkuPaintingPlanView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/handPaintingPlan")({
	staticData: { title: "TS, käsimaalaus", legacyViewKey: "mellanoLuukkuHandPaintingPlanView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuPaintingPlanView productionLine={"4"} />;
}
